/**
 * Recursive merge for locale objects. `override` wins at a leaf, and every
 * sibling key on both sides survives.
 *
 * A shallow spread is the trap: `{ ...base, el: override }` replaces the whole
 * `el` subtree, so every library string the override does not name is lost and
 * the component prints a raw key such as `el.select.noData`.
 */
export function deepMerge(base, override) {
  if (override === undefined) {
    return base
  }

  const isPlainObject = (value) =>
    value !== null && typeof value === 'object' && !Array.isArray(value)

  if (!isPlainObject(base) || !isPlainObject(override)) {
    return override
  }

  const merged = { ...base }

  for (const [key, value] of Object.entries(override)) {
    merged[key] = key in base ? deepMerge(base[key], value) : value
  }

  return merged
}
